import React, { useEffect } from "react";
import { CiFilter } from "react-icons/ci";
import { RxCross1 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { getBranchAction } from "../../Actions/BranchAction/BranchAction";

const SearchStatisticsModal = ({
  onClose,
  searchParam,
  handleChangeParams,
  handleSearch,
}) => {
  const getBranch = useSelector((state) => state.getBranch);
  const { branches } = getBranch;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBranchAction());
  }, []);
  const handleClose = (event) => {
    event.preventDefault();
    onClose();
  };
  return (
    <div>
      <form action="">
        <p className="text-center rounded-sm shadow-md bg-yellow-500 p-2 text-gray-50">
          بەرواری داخلکردنی فۆرم
        </p>
        <div className="flex gap-2 items-center my-2">
          <input
            type="date"
            onChange={handleChangeParams}
            value={searchParam.from}
            name="from"
            className="input w-full"
            id=""
          />
          <p>To</p>
          <input
            onChange={handleChangeParams}
            value={searchParam.to}
            type="date"
            name="to"
            className="input w-full"
            id=""
          />
        </div>
        <hr />
        <div className="flex gap-2 my-2 items-center">
          <div className="flex flex-col gap-1 w-full">
            <label htmlFor="branch">Branch</label>
            <select
              onChange={handleChangeParams}
              value={searchParam.branch}
              name="branch"
              className="input w-full "
              id="branch"
            >
              <option value="">Select Branch</option>
              {branches?.map((branch) => {
                return (
                  <option key={branch.id} value={branch.id}>
                    {branch.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="flex flex-col gap-1 w-full">
            <label htmlFor="approve">Approve </label>
            <select
              onChange={handleChangeParams}
              value={searchParam.approve}
              name="approve"
              className="input w-full "
              id="approve"
            >
              <option value="">Select Approve </option>
              <option value="0">Yes</option>
              <option value="1">No</option>
            </select>
          </div>
        </div>

        <hr />

        <p className="text-center rounded-sm shadow-md bg-green-500 mt-2 p-2 text-gray-50">
          بەرواری داخلکردنی نەشتەرگەری
        </p>
        <div className="flex gap-2 items-center my-2">
          <input
            type="date"
            onChange={handleChangeParams}
            value={searchParam.from_surgery}
            name="from_surgery"
            className="input w-full"
            id=""
          />
          <p>To</p>
          <input
            type="date"
            onChange={handleChangeParams}
            value={searchParam.to_surgery}
            name="to_surgery"
            className="input w-full"
            id=""
          />
        </div>
        <hr />
        <div className="flex gap-2 my-2 items-center">
          <div className="flex flex-col gap-1 w-full">
            <label htmlFor="surgery">Surgery</label>
            <select
              name="surgery"
              onChange={handleChangeParams}
              value={searchParam.surgery}
              className="input w-full "
              id="surgery"
            >
              <option value="">Select Surgery</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>

          <div className="flex flex-col gap-1 w-full">
            <label htmlFor="medical">Medical Suplies</label>
            <select
              name="medical"
              onChange={handleChangeParams}
              value={searchParam.medical}
              className="input w-full "
              id="medical"
            >
              <option value="">Select Medical Suplies</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
        <div className="flex gap-2 items-center mt-2">
          <button
            onClick={() => {
              handleSearch();
              onClose();
            }}
            className="btn-primary flex gap-2 items-center mt-3"
          >
            Filter <CiFilter />
          </button>

          <button
            onClick={handleClose}
            className="btn-danger flex gap-2 items-center mt-3"
          >
            Clear <RxCross1 />
          </button>
        </div>
      </form>
    </div>
  );
};

export default SearchStatisticsModal;
